import { createSlice, nanoid, type PayloadAction } from '@reduxjs/toolkit';

export interface AppNotification {
  id: string;
  severity: 'success' | 'error' | 'info' | 'warning';
  message: string;
  reportId?: string;
}

export interface NotificationsState {
  items: AppNotification[];
}

const initialState: NotificationsState = {
  items: [],
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    notificationAdded: {
      reducer(state, action: PayloadAction<AppNotification>) {
        state.items.push(action.payload);
      },
      prepare(payload: Omit<AppNotification, 'id'>) {
        return {
          payload: {
            ...payload,
            id: nanoid(),
          },
        };
      },
    },
    notificationDismissed(state, action: PayloadAction<string>) {
      state.items = state.items.filter((notification) => notification.id !== action.payload);
    },
  },
});

export const { notificationAdded, notificationDismissed } = notificationsSlice.actions;
export const notificationsReducer = notificationsSlice.reducer;

export const selectNotifications = (state: {
  notifications: NotificationsState;
}): AppNotification[] => state.notifications.items;
